import { render, staticRenderFns } from "./fault-detail.vue?vue&type=template&id=88167106&scoped=true&"
import script from "./fault-detail.vue?vue&type=script&lang=js&"
export * from "./fault-detail.vue?vue&type=script&lang=js&"
import style0 from "./fault-detail.vue?vue&type=style&index=0&id=88167106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88167106",
  null
  
)

export default component.exports